export default {
  badge: "Badge",
  close: "Close",
  dataIterator: {
    noResultsText: "No matching records found",
    loadingText: "Loading items...",
  },
  dataTable: {
    itemsPerPageText: "Rows per page:",
    ariaLabel: {
      sortDescending: "Sorted descending.",
      sortAscending: "Sorted ascending.",
      sortNone: "Not sorted.",
      activateNone: "Activate to remove sorting.",
      activateDescending: "Activate to sort descending.",
      activateAscending: "Activate to sort ascending.",
    },
    sortBy: "Sort by",
  },
  dataFooter: {
    itemsPerPageText: "Items per page:",
    itemsPerPageAll: "All",
    nextPage: "Next page",
    prevPage: "Previous page",
    firstPage: "First page",
    lastPage: "Last page",
    pageText: "{0}-{1} of {2}",
  },
  datePicker: {
    itemsSelected: "{0} selected",
    nextMonthAriaLabel: "Next month",
    nextYearAriaLabel: "Next year",
    prevMonthAriaLabel: "Previous month",
    prevYearAriaLabel: "Previous year",
  },
  noDataText: "No data available",
  carousel: {
    prev: "Previous visual",
    next: "Next visual",
    ariaLabel: {
      delimiter: "Carousel slide {0} of {1}",
    },
  },
  calendar: {
    moreEvents: "{0} more",
  },
  fileInput: {
    counter: "{0} files",
    counterSize: "{0} files ({1} in total)",
  },
  timePicker: {
    am: "AM",
    pm: "PM",
  },
  pagination: {
    ariaLabel: {
      wrapper: "Pagination Navigation",
      next: "Next page",
      previous: "Previous page",
      page: "Goto Page {0}",
      currentPage: "Current Page, Page {0}",
    },
  },
  crm: {
    default: {
      button: {
        confirm: "Confirm",
        cancel: "Cancel",
      },
    },
    contact: {
      address: {
        address: "Street Address",
        postalCode: "Zip Code",
        city: "City",
        region: "State/Province",
        country: "Country",
      },
    },
    content: {
      sign: {
        label: "Sign",
        title: "E-signature",
        parties: {
          title: "Parties",
        },
        role: {
          signatory: "Signatory",
          reviewer: "Reviewer",
        },
        status: {
          pending: "Waiting for signature",
          signed: "Has signed the document",
        },

        comments: {
          label: "Kommentar",
          placeholder: "Kommentera",
          thanks: "Tack för din kommentar",
        },
        review: {
          label: "Granska dokument",
        },
        confirm: {
          label: "Confirm",
          text1: "I hereby confirm that I am {0}",
          text2: " and represents {0}",
          text3: ". I also confirm that I own the right to sign this document.",
          done: "Thank you! You have now signed the document",
        },
      },
    },
  },
  inspectech: {
    order: {
      form: {
        mandatory: "*) Mandatory information",
        orderType: {
          help: "Please select your order",
          label: "Type of order",
        },
        inspectionTypes: {
          help: "Please select products",
          label: "I'm interested in *",
          required: "You must select a product",
        },
        customer: {
          help: "Customer information",
          label: "Customer information",
          companyName: {
            help: "Company name",
            label: "Customer's company name (if applicable)",
          },
          firstName: {
            help: "Customer first name",
            label: "First name *",
          },
          lastName: {
            help: "Customer last name",
            label: "Last name *",
          },
          phone: {
            help: "Customer phone number",
            label: "Phone *",
          },
          email: {
            help: "Customer email",
            label: "Email *",
          },
          number: {
            help: "Customer social security number (for invoicing)",
            label: "Social security number",
          },
        },
        broker: {
          help: "Real estate broker information",
          label: "Broker",
          companyName: {
            help: "Broker company",
            label: "Name of real estate broker company",
          },
          firstName: {
            help: "Broker first name",
            label: "First name",
          },
          lastName: {
            help: "Broker last name",
            label: "Last name",
          },
          phone: {
            help: "Broker phone number",
            label: "Phone",
          },
          email: {
            help: "Broker email",
            label: "Email",
          },
          number: {
            help: "Broker company id",
            label: "Company id",
          },
        },
        estate: {
          help: "Real estate information",
          label: "Real estate",
          copyAddress: "Copy name and address from customer",
          owner1: {
            firstName: {
              label: "Owner first name",
            },
            lastName: {
              label: "Owner last name",
            },
          },
          owner2: {
            firstName: {
              label: "Second owner first name",
            },
            lastName: {
              label: "Second owner last name",
            },
          },
          location: {
            label: "Municipality *",
            required: "Municipality is required",
          },
          number: {
            label: "Real estate id *",
            required: "Real estate id is required",
          },
        },
        date: {
          help: "Desired date",
          label: "Desired date",
          disclaimer:
            "The requested inspection date in connection with the order" +
            " does not constitute a guarantee that we can carry out" +
            " the assignment on that day. The booking, both date and time," +
            " is confirmed in writing by us and is stated in the assignment confirmation.",
        },
        calendar: {
          link: {
            label: "See our detailed calendar",
          },
        },
        privacy: {
          help: "Privacy policy",
          label:
            "In accordance with GDPR, I agree that my personal data will be saved in connection with this order/quote request.",
          required:
            "You must agree to the storage of personal data in order to order.!",
          link: "Read about how we process personal data here.",
        },
        submit: {
          help: "Submit order",
          label: "Submit",
          success: "Sending order...",
          error: "The order could not be sent!",
        },
      },
      confirm: {
        header: "Thank you!",
        message:
          "We will get back to you shortly with information about your booking and assignment confirmation.",
        website: "Back to {0}",
      },
      calendar: {
        today: "Today",
        type: {
          day: "Day",
          week: "Week",
          month: "Month",
        },
      },
    },
  },
};
